module.exports = __webpack_public_path__ + "static/img/box-close.d9d899bb.webp";